/**
 * Abstract superclass for database entities, used with AbstractCRUDService
 */
export class AbstractModel {
  /**
   * Database id, autogenerated, do not edit
   */
  id: number;
  /**
   * Entity creation timestamp, do not edit, this is set by API
   */
  createdAt: Date;
  /**
   * Entity modification timestamp, do not edit, this is set by API
   */
  updatedAt: Date;
  /**
   * Entity deleted timestamp, do not edit, this is set by API
   */
  deletedAt: Date;
}
